












































































// Vue
import { defineComponent, Ref, ref, PropType, computed } from '@vue/composition-api'

// vuelidate
import useVuelidate from '@vuelidate/core'
import { required, email } from 'vuelidate/lib/validators'

// components
import { Input, SwitchToggle, Select, Radio } from '@/components/form'

// constants
import { ROLES_USER } from '@/constants/roles'
import { optionsStatus } from '@/constants'

// models
import { PropOptionSelect, UserInput } from '@/models'

// utils
import { alerts, loading } from '@/utils'

// services
import { UsersService } from '@/services/config'

const USER_INIT: UserInput = {
  name: '',
  email: '',
  role_id: ROLES_USER.USER_PIECEWORK,
  is_active: true,
  password: '',
  password_confirmation: ''
}

export default defineComponent({
  name: 'FormUser',
  components: {
    Input,
    SwitchToggle,
    Select,
    Radio
  },
  props: {
    actionForm: {
      type: String as PropType<'create'|'edit'>,
      required: true
    },
    idEdit: {
      type: Number
    },
    user: {
      type: Object as PropType<UserInput>
    }
  },
  setup (props, { emit }) {
    const emailValid = ref(true)
    const oldEmail = ref('')
    const roles: Ref<PropOptionSelect[]> = ref([
      { value: ROLES_USER.SUPER_ADMIN, text: 'Super Admin' },
      { value: ROLES_USER.ADMIN, text: 'Administrador' },
      { value: ROLES_USER.USER_PIECEWORK, text: 'Usuario - Destajo' },
      { value: ROLES_USER.USER_ASSISTANCE, text: 'Usuario - Asistencia' }
    ])

    const rules = computed(() => {
      if (props.actionForm === 'create') {
        return {
          form: {
            name: { required },
            email: { required },
            password: { required },
            password_confirmation: { required },
            role_id: { required }
          }
        }
      }
      return {
        form: {
          name: { required },
          email: { required, email },
          role_id: { required },
          password: { required: false },
          password_confirmation: { required: false }
        }
      }
    })

    const form: Ref<UserInput> = ref({
      ...USER_INIT
    })

    if (props.user) {
      const u = props.user
      form.value = {
        name: u.name,
        email: u.email,
        role_id: u.role_id,
        is_active: u.is_active,
        password: '',
        password_confirmation: ''
      }
      oldEmail.value = u.email
    }

    const handleChangeEmail = async () => {
      if (oldEmail.value !== form.value.email) {
        const userByEmail = await UsersService.getAll(form.value.email)
        if (userByEmail.length > 0) {
          emailValid.value = false
        } else {
          emailValid.value = true
        }
      }
    }

    // @ts-ignore
    const $v = useVuelidate(rules, { form: form.value })

    const save = async () => {
      if (!emailValid.value) {
        return alerts.error('Email ya se encuentra registrado.')
      }
      if (form.value.password !== form.value.password_confirmation) {
        return alerts.error('Contraseña no coinciden')
      }
      if (!$v.value.form.$invalid) {
        try {
          loading('show')
          if (props.actionForm === 'create') {
            await UsersService.create(form.value)
          } else {
            await UsersService.update(Number(props.idEdit), form.value)
          }
          loading('hide')
          alerts.success()
          emit('save-success')
        } catch (e) {
          alerts.error('ERROR.! No se pudo completar la operación')
          loading('hide')
        }
      } else {
        alerts.error('Debe completar todos los campos')
      }
    }

    return {
      roles,
      optionsStatus,
      save,
      $v,
      form,
      handleChangeEmail
    }
  }
})
